<template lang="pug">
  .height-100
    .modal.is-active(
      key="modal-editar"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      v-if="mostrarConfirmacionEliminar"
      )
      transition(
        name='fade',
        tag="div",
        )
        confirmar-accion-overlay(
          @close="mostrarConfirmacionEliminar = false"
          @do="eliminar()"
        )
          span(slot="title") {{ confirmacionEliminarTitulo }}
          span(slot="information") {{ confirmacionEliminarDescripcion }}
          span(slot="primaryAction")
            template(v-if="isSendingEliminar")
              | Eliminando...
            template(v-else)
              | Eliminar
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalAdjuntar"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
        )
        upload-image(
          name="curso_virtual",
          folder="curso_virtual_portada",
          @save="guardarAdjunto"
          @close="closeModalAdjuntar"
          :onlyImg="true"
          )
          span(slot="title") Adjuntar archivo
          span(slot="explanation") Adjunta el archivo  deseado
          i.fa.fa-file(slot="topIcon")
    .title.pt-5
      span.fw-400 {{ id ? 'Editar' : 'Nuevo' }} curso virtual
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .display-flex.mb-5
          .volver.display-flex.flex-1
            button.button.is-small(@click="volver()")
              span.icon.is-small
                i.fa.fa-arrow-left
              span Volver
          button.button.is-small.is-primary(@click="guardarCurso()")
            span.icon.is-small
              i.fa.fa-floppy-o
            span Guardar
        .body.pt-10
          .title
            .display-flex

              .control.margin-bottom-10.flex-1
                p.margin-bottom-5 Título
                input.input(
                  type="text",
                  v-model="titulo"
                  :disabled="isLoadingCurso"
                )

              .control.margin-bottom-10.text-center
                p.margin-bottom-5 Activo
                input.checkbox(
                  type="checkbox",
                  v-model="activo"
                  :disabled="isLoadingCurso"
                )

            .control.margin-bottom-10
              p.margin-bottom-5 Descripción
              textarea.textarea.w-300(
                style="field-sizing: content !important;",
                v-model="descripcion"
                :disabled="isLoadingCurso"
              )
            .control.margin-bottom-10.text-center
              button.button.is-small.is-primary(@click="openModalAdjuntar" v-if="!imagen")
                span.icon.is-small
                  i.fa.fa-upload.is-small
                span.is-small Adjuntar portada
              button.button.is-small.is-danger(@click="imagen = ''" v-else)
                span.icon.is-small
                  i.fa.fa-trash.is-small
                span Borrar Portada
            .img(v-if="imagen")
              img(:src="imagen" alt="portada_curso")


        .display-flex.fdr.space-evenly.flex-wrap.pt-10
          .caja.lista-solicitud-vacaciones.contenedor-interno
            materiales-curso-lista(type="curso" @save="saveMaterial()" ref="materialesRef")
          .caja.lista-solicitud-vacaciones.contenedor-interno
            evaluaciones-curso-lista(type="curso" @save="saveEvaluacion()" ref="evaluacionesRef")
          .caja.lista-solicitud-vacaciones.contenedor-interno
            alumnos-curso-lista(@save="saveAlumno()" ref="alumnosRef")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-clases")
        .title.pt-5
          span.clase Clases
        .text-right
          button.button.is-small.margin-right-5.is-primary(@click="redirigir(0)")
            span.icon.is-small
              i.fa.fa-plus
            span Nuevo
          button.button.is-small(v-if="lista.length !== 0" @click="fetchClases()")
            span.icon.is-small
              i.fa.fa-refresh
            span Refrescar
        .body
          .is-loading(v-if="isLoadingClase")
            .icon
              i.fa.fa-spinner.fa-spin
          .information(v-else)
            template(v-if="lista.length !== 0")
              .is-desktop
                table.table.is-striped.is-bordered
                  thead
                    th Orden
                    th Título
                    th Descripción
                    th
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                      :class="{'is-close': !o.activo}"
                    )
                      td {{ o.orden }}
                      td
                        .hint--top(:aria-label="'ID: ' + o.id") {{ o.titulo }}
                      td {{ o.descripcion | truncateText }}
                      td.text-center
                        .contenedor-acciones
                          button.button.is-small.mr-5(@click="redirigir(o.id)")
                            span.icon.is-small
                              i.fa.fa-pencil-square-o
                            span Editar
                          button.button.is-small.is-danger(@click="confirmarEliminar(o)")
                            span.icon.is-small
                              i.fa.fa-times
                            span Eliminar
              .is-mobile
                .box(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'is-close': !o.activo}"
                )
                  .descripcion-tipo
                    span.hint--top(:aria-label="'ID: ' + o.id") {{ o.titulo }}
                  .motivo(v-if="o.descripcion")
                    div
                      span {{ o.descripcion | truncateText }}
                  .dias-pedidos(v-if="o.orden")
                    strong Orden: {{ o.orden }}
                  .contenedor-acciones
                    button.button.is-small.mr-5(@click="redirigir(o.id)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                      span Editar
                    button.button.is-small.is-danger(@click="confirmarEliminar(o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Eliminar
            div(v-else)
              .message.is-warning
                .message-body No hay clases registradas

</template>

<script>
import ComponentConfirmarAccionOverlay from '../components/Component_Confirmar_Accion_Overlay';
import MaterialesLista from '../components/c_materiales_lista'
import EvaluacionesLista from '../components/c_evaluaciones_lista'
import AlumnosLista from '../components/c_alumnos_lista'
import UploadImage from '../components/Component_Upload_Image'
import { apiGet, apiPost, apiPut, apiDelete, notify } from '../util/general'
export default {
  name: 'gestion-cursos-virtuales-editar',
  data () {
    return {
      lista         :[],
      isLoadingCurso:false,
      isLoadingClase:false,
      id            :'',
      titulo        :'',
      descripcion   :'',
      imagen        :'',
      localPath: '',
      confirmacionEliminarId:'',
      confirmacionEliminarTitulo:'',
      confirmacionEliminarDescripcion:'',
      mostrarConfirmacionEliminar:false,
      isSendingEliminar:'',
      activo        :0,
      mostrarModalAdjuntar : false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'materiales-curso-lista' : MaterialesLista,
    'evaluaciones-curso-lista' : EvaluacionesLista,
    'upload-image': UploadImage,
    'alumnos-curso-lista' : AlumnosLista,
    'confirmar-accion-overlay' : ComponentConfirmarAccionOverlay
  },
  created () {
  },
  mounted () {
    this.id = +this.$route.params.id
    if (this.id) {
      this.fetchCurso()
      this.fetchClases()
    }
  },
  methods: {
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      vm.imagen = fileSubido.file.ruta
      vm.localPath = fileSubido.file.localPath
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    confirmarEliminar (o) {
      var vm = this
      vm.confirmacionEliminarId = o.id
      vm.confirmacionEliminarTitulo = 'Eliminar clase'
      vm.confirmacionEliminarDescripcion = 'Al eliminar la clase, eliminará las evaluaciones y materiales.'

      vm.mostrarConfirmacionEliminar = true
    },
    eliminar () {
      var vm = this
      vm.isSendingEliminar = true
      apiDelete(vm, '/curso/gestion/' + vm.id + '/clase/' + vm.confirmacionEliminarId, {}, function (data) {
        notify(vm, 'success', 'Éxito', 'Clase eliminada con éxito.')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSendingEliminar = false
        vm.mostrarConfirmacionEliminar = false
        vm.fetchClases()
      })
    },
    volver () {
      var vm = this
      vm.$router.push('/gestion-cursos')
    },
    redirigir (idClase) {
      var vm = this
      if (!vm.id) {
        // dentor de insertar hará la redireccion
        vm.guardarCurso(true)
        return
      }
      vm.$router.push(vm.id + '/gestion-clases/' + idClase)
    },
    fetchCurso () {
      var vm = this
      vm.isLoadingCurso = true
      apiGet(vm, '/curso/gestion/' + vm.id, {}, function (data) {
        const { titulo, descripcion, imagen, activo } = data.curso
        vm.titulo      = titulo
        vm.imagen      = imagen
        vm.activo      = activo
        vm.descripcion = descripcion
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.$router.push('/gestion-cursos')
      }, function () {
        vm.isLoadingCurso = false
      })
    },
    fetchClases () {
      var vm = this
      vm.isLoadingClase = true
      apiGet(vm, '/curso/gestion/' + vm.id + '/clase', {}, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingClase = false
      })
    },
    saveMaterial () {
      this.guardarCurso(null, true)
    },
    saveEvaluacion () {
      this.guardarCurso(null, null, true)
    },
    saveAlumno () {
      this.guardarCurso(null, null, null, true)
    },
    guardarCurso (toClase, toMaterial, toEvaluacion, toAsignarEmpleados) {
      if (!this.titulo) {
        notify(this, 'error', 'Error', 'Debe escribir un título para el curso.')
        return
      }
      if (this.id) {
        this.actualizarCurso()
      } else {
        this.insertarCurso(toClase, toMaterial, toEvaluacion, toAsignarEmpleados)
      }
    },
    insertarCurso (toClase, toMaterial, toEvaluacion, toAsignarEmpleados) {
      var vm = this
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        imagen: vm.imagen,
        activo: vm.activo
      }
      apiPost(vm, '/curso', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Nuevo curso guardado correctamente')
        vm.id = data.id
        vm.$router.push('/gestion-cursos/' + vm.id)
        vm.fetchCurso()
        if (toClase) vm.$router.push(vm.id + '/gestion-clases/0')
        else if (toMaterial) vm.$refs.materialesRef.abrirModalEditar()
        else if (toEvaluacion) vm.$refs.evaluacionesRef.abrirModalEditar()
        else if (toAsignarEmpleados) vm.$refs.alumnosRef.abrirModalAsignarEmpleados()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    actualizarCurso () {
      var vm = this
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        imagen: vm.imagen,
        activo: vm.activo
      }
      apiPut(vm, '/curso/gestion/' + vm.id, obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Curso actualizado correctamente')
        vm.fetchCurso()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .textarea
    height: auto;
  .is-mobile
    .is-close
      background-color #ffd6d6 !important
  .caja
    display: block;
    padding: 0.5rem;
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span.clase
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;
  .is-mobile
    display none
    .box
      position: relative;
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  .contenedor-acciones
    display flex
    justify-content center
  .img
    padding-bottom: 10px
    img
      max-width 100%
      width 500px
      height auto
      border-radius 5px
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width 710px)
    .is-mobile
      display block

    .is-desktop
      display none
    .contenedor-acciones
      margin-top 5px
  @media (max-width 650px)
    .contenedor-acciones
      flex-direction: row
      margin-top 5px
      .button
        margin-bottom 5px
        &:last-child
          margin-bottom 0px

  @media (max-width: 500px)
    .caja
      width: 100%;

</style>




// WEBPACK FOOTER //
// View_Gestion_Cursos_Editar.vue?d1905c72